export const relays = state => state.relays
export const relay = state => state.relay
export const relayTags = state => state.relayTags

export const defaultRelay = (state) => {
  return state.relays.find(relay => relay.tags.includes("default"))
}
